<template>
  <div>
    <h4 class="title is-4">Спасибо за ваш заказ.</h4>
    <p>Ваш заказ <b>№{{order.id}}</b> оформлен. В скором времени с вами свяжется наш
      менеджер для подтверждения заказа.</p>
  </div>
</template>

<script>
  /**
   * Показ уведомления об успешном заказе.
   */
  export default {
    name: 'finish-step',
    props: {
      order: {
        type: Object,
        required: true
      }
    }
  }
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// FinishStep.vue?19b74be6